module.exports = __webpack_public_path__ + "assets/img/new_local.124d6a56.jpg";